import React, { ReactNode } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import { TreeItem } from '@mui/x-tree-view';

type CheckBoxTreeItemProps = {
  id: number;
  label: string;
  checked: boolean;
  children?: ReactNode;
  onChange?: (event: any) => void;
};

const CheckBoxTreeItem: React.FC<CheckBoxTreeItemProps> = ({
  id,
  label,
  checked,
  onChange,
  children,
}) => {
  const classes = useStyles();
  return (
    <TreeItem
      key={id}
      nodeId={`${id}`}
      label={
        <FormControlLabel
          key={id}
          control={
            <Checkbox checked={checked} onChange={onChange} onClick={(e) => e.stopPropagation()} />
          }
          label={<Typography className={classes.treeItemLabel}>{label}</Typography>}
        />
      }
    >
      {children}
    </TreeItem>
  );
};

const useStyles = makeStyles(() => ({
  treeItemLabel: {
    fontSize: remCalc(16),
    lineHeight: remCalc(24),
  },
}));

export default CheckBoxTreeItem;
